module.exports = __webpack_public_path__ + "static/media/sz.a637d912.png";